
import { useNavigate } from "react-router-dom";

// icons
import { FiInfo } from "react-icons/fi";
import IconComponent from "./Icon";
import { FaBook, FaBookReader, FaCheck } from "react-icons/fa";
import { BsFillBookmarkFill } from "react-icons/bs";

// constants
import { book } from "../assets/data/constants"

const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';


interface BookProps {
    book: book;
    key: number;
    hideMeta?: boolean;
}

const Book: React.FC<BookProps> = ({book, key, hideMeta = false}) => {
    const navigate = useNavigate();

    return(
        <div key={key}>
            <div className="relative w-32 h-48">
            <img src={book['Cover URL'] || noCover } alt={book['Title']} className="w-32 h-48 object-cover rounded-lg" />  
            {
                (book['In User Library']) ?
                    <div className="absolute top-0 left-0 flex items-center justify-center rounded-br-lg rounded-tl-lg">
                        <IconComponent icon={BsFillBookmarkFill} width={30} color="#EDB04D" className="" />
                        {
                            (book['Read Count'] > 0) &&
                                <div className="absolute top-50 right-50">
                                    <IconComponent icon={FaCheck} width={12} color="#60637A" />
                                </div>
                        }
                        {
                            (book['Exclusive Shelf'] === 'currently-reading') &&
                                <div className="absolute top-50 right-50">
                                    <IconComponent icon={FaBookReader} width={12} color="#60637A" />
                                </div>
                        }
                    </div> : <></>
            }
            {
                (book['Owned Copies'] > 0) ?
                    <div className="absolute bottom-0 right-0 p-1 bg-[#ffffff]  flex items-center justify-center rounded-tl-lg rounded-br-lg">
                        <IconComponent icon={FaBook} width={20} color="#EDB04D" />
                    </div> : <></>
            }
                <div 
                className="absolute top-0 left-0 right-0 bottom-0 h-full bg-black bg-opacity-75 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer"
                onClick={() => navigate(`/Book/${book['Book Id']}`)}
                >
                <IconComponent icon={FiInfo} width={30} color="#ffffff" className="drop-shadow-xl" />
                </div>
            </div>
            {!hideMeta && 
                <>
                    <p className="font-bold">{book['Title']}</p>
                    <p className="italic text-xs">{book['Author']}</p>
                </>
            }
           
        </div>
    )

}

export default Book